export default {
	home: '/en',
	contact: '/contact',
	dummyData: 'dummy-data',
};
